import type { Observable } from '@acies/observables';
import type { SimpleOrganization } from '../simple-organization';
import type User from '../user';
import type PhasesCO2 from './phases-co2';

interface IComponentCO2 {
	readonly createdAt: Date;
	readonly createdBy: null | SimpleOrganization | User;
	readonly description: string;
	readonly epd: string;
	readonly name: string;
	readonly phases: PhasesCO2;
	readonly selected: Observable<boolean>;
	readonly self: string;
	readonly updatedAt: Date;
	readonly updatedBy: null | SimpleOrganization | User;
	readonly version: number;
}

export default class ComponentCO2 implements IComponentCO2 {
	public get createdAt(): Date {
		return this.#createdAt;
	}

	public get createdBy(): null | SimpleOrganization | User {
		return this.#createdBy;
	}

	public get createdByFormatted(): string {
		if (this.#createdBy && this.#createdBy.name) {
			return this.#createdBy.name;
		}
		return '';
	}

	public get description(): string {
		return this.#description;
	}

	public get epd(): string {
		return this.#epd;
	}

	public get name(): string {
		return this.#name;
	}

	public get phases(): PhasesCO2 {
		return this.#phases;
	}

	public get selected(): Observable<boolean> {
		return this.#selected;
	}

	public get self(): string {
		return this.#self;
	}

	public get updatedAt(): Date {
		return this.#updatedAt;
	}

	public get updatedAtFormatted(): string {
		return this.#updatedAt.toLocaleDateString('da-DK', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		});
	}

	public get updatedBy(): null | SimpleOrganization | User {
		return this.#updatedBy;
	}

	public get updatedByFormatted(): string {
		if (this.#updatedBy && this.#updatedBy.name) {
			return this.#updatedBy.name;
		}
		return '';
	}

	public get version(): number {
		return this.#version;
	}

	#createdAt: Date;
	#createdBy: null | SimpleOrganization | User;
	#description: string;
	#epd: string;
	#name: string;
	#phases: PhasesCO2;
	#selected: Observable<boolean>;
	#self: string;
	#updatedAt: Date;
	#updatedBy: null | SimpleOrganization | User;
	#version: number;
	public constructor({ createdAt, createdBy, description, epd, name, phases, selected, self, updatedAt, updatedBy, version }: IComponentCO2) {
		this.#createdAt = createdAt;
		this.#createdBy = createdBy;
		this.#description = description;
		this.#epd = epd;
		this.#name = name;
		this.#phases = phases;
		this.#selected = selected;
		this.#self = self;
		this.#updatedAt = updatedAt;
		this.#updatedBy = updatedBy;
		this.#version = version;
	}
}
